// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file subscription/v1/addon_usage.proto (package subscription.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Timestamp } from '@bufbuild/protobuf/wkt';
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt';
import type { Feature } from './addon_pb';
import { file_subscription_v1_addon } from './addon_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file subscription/v1/addon_usage.proto.
 */
export const file_subscription_v1_addon_usage: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiFzdWJzY3JpcHRpb24vdjEvYWRkb25fdXNhZ2UucHJvdG8SD3N1YnNjcmlwdGlvbi52MSKqAgoKQWRkb25Vc2FnZRIKCgJpZBgBIAEoBBImCgRuYW1lGAIgASgOMhguc3Vic2NyaXB0aW9uLnYxLkZlYXR1cmUSDQoFdmFsdWUYAyABKAkSDQoFcHJpY2UYBCABKAESOgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmNyZWF0ZWRfYXQSOgoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCnVwZGF0ZWRfYXQSOgoKZGVsZXRlZF9hdBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmRlbGV0ZWRfYXQSFgoOY3VycmVudGx5X3VzZWQYCCABKAlCiQEKE2NvbS5zdWJzY3JpcHRpb24udjFCD0FkZG9uVXNhZ2VQcm90b1ABWgQuL3BiogIDU1hYqgIPU3Vic2NyaXB0aW9uLlYxygIPU3Vic2NyaXB0aW9uXFYx4gIbU3Vic2NyaXB0aW9uXFYxXEdQQk1ldGFkYXRh6gIQU3Vic2NyaXB0aW9uOjpWMWIGcHJvdG8z',
        [file_google_protobuf_timestamp, file_subscription_v1_addon]
    );

/**
 * @generated from message subscription.v1.AddonUsage
 */
export type AddonUsage = Message<'subscription.v1.AddonUsage'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: subscription.v1.Feature name = 2;
     */
    name: Feature;

    /**
     * @generated from field: string value = 3;
     */
    value: string;

    /**
     * @generated from field: double price = 4;
     */
    price: number;

    /**
     * @generated from field: google.protobuf.Timestamp created_at = 5 [json_name = "created_at"];
     */
    createdAt?: Timestamp | undefined;

    /**
     * @generated from field: google.protobuf.Timestamp updated_at = 6 [json_name = "updated_at"];
     */
    updatedAt?: Timestamp | undefined;

    /**
     * @generated from field: google.protobuf.Timestamp deleted_at = 7 [json_name = "deleted_at"];
     */
    deletedAt?: Timestamp | undefined;

    /**
     * currently_used is a string on purpose — the Shopify-embedded admin UI parses
     * it as a string. Do not change to a numeric type.
     *
     * @generated from field: string currently_used = 8;
     */
    currentlyUsed: string;
};

/**
 * Describes the message subscription.v1.AddonUsage.
 * Use `create(AddonUsageSchema)` to create a new message.
 */
export const AddonUsageSchema: GenMessage<AddonUsage> = /*@__PURE__*/ messageDesc(file_subscription_v1_addon_usage, 0);
